query DashboardWfaSessions(
    $offset: Int!
    $limit: Int!
    $sort: wfa_session_runsSort
    $daysAmountFilter: ConditionInt
    $customFieldsFilter: ConditionStringArray
    $customFieldsFilterExcludes: ConditionStringArray
    $environmentCustomFieldsFilter: ConditionStringArray
    $environmentsFilter: ConditionString
) {
    wfa_session_runs(
        offset: $offset
        limit: $limit
        sort: $sort
        run_time_last_n_days: $daysAmountFilter
        custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
        and: [
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter }
                    { environments_eq_any_item: $environmentsFilter }
                ]
            }
            { custom_fields_eq_any_item_for_any_value: $customFieldsFilter }
        ]
    ) {
        run_id
        session_name
        total_issues
        critical_issues
        serious_issues
        run_time
        user_name
    }
    total: wfa_session_runs(
        run_time_last_n_days: $daysAmountFilter
        custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
        and: [
            {
                or: [
                    { custom_fields_eq_any_item_for_any_value: $environmentCustomFieldsFilter }
                    { environments_eq_any_item: $environmentsFilter }
                ]
            }
            { custom_fields_eq_any_item_for_any_value: $customFieldsFilter }
        ]
    ) {
        run_id_count
    }
    unfiltered_total: wfa_session_runs {
        run_id_count
    }
}
